interface Props {
  color?: string
  width?: number
  height?: number
}

// Outline board with three inset frames (top-left wide, bottom-left square,
// right tall) — reads as "moodboard with a few items on it." Matches the
// thin single-stroke style of the other sidebar icons. The outer board fills
// nearly the full viewBox so the optical mass matches sibling icons.
export const MoodboardIcon = ({ color = '#6F6F6F', width = 22, height = 22 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="2" width="20" height="18" rx="2" stroke={color} strokeLinejoin="round" />
      <rect x="3" y="4.5" width="5.5" height="4" rx="0.75" stroke={color} strokeLinejoin="round" />
      <rect x="3" y="10.5" width="5.5" height="7" rx="0.75" stroke={color} strokeLinejoin="round" />
      <rect
        x="10.5"
        y="4.5"
        width="8"
        height="13"
        rx="0.75"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  )
}
